// extracted by mini-css-extract-plugin
export default {"container":"style_container__heDcY","box":"style_box__yUUR+","door":"style_door__SXYvx"};